
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[collezioni]",
      function () {
        return require("private-next-pages/collections/[collezioni].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[collezioni]"])
      });
    }
  